<template>
  <div v-if="templatesLoading" />
  <update-editor
    v-else
    @cancel="$router.replace({ name: routeName.teamsTeamOkrs, query: { view: UPDATE_VIEW }})"
    @create="created"
  />
</template>

<script>
import UpdateEditor from '@/components/updates/UpdateEditor.vue';
import useUpdateTemplates from '@/composables/update-templates/update-templates';
import { UPDATE_VIEW } from '@/route-params';
import { routeName } from 'shared/constants.json';

export default {
  name: 'MSTeamsUpdatEditor',
  components: { UpdateEditor },
  setup() {
    const updateTemplatesSvc = useUpdateTemplates();
    return {
      fetchUpdateTemplates: updateTemplatesSvc.fetchUpdateTemplates,
      templatesLoading: updateTemplatesSvc.fetchUpdateTemplatesLoading,
    };
  },
  data() {
    return { routeName, UPDATE_VIEW };
  },
  methods: {
    created() {
      this.$router.replace({ name: routeName.teamsTeamOkrs, query: { view: UPDATE_VIEW } });
    },
  },
  created() {
    this.fetchUpdateTemplates();
  },
};
</script>

<style>
</style>
